import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    qaList: [],
    qa: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
      tab: null,
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.qaList = [];
      state.qa = null;
      state.filter = {
        keyword: null,
        status: null,
        tab: null,
      };
    },
    SET_QALIST(state, data) {
      state.qaList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_QA(state, data) {
      state.qa = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setQA({ commit }, data) {
      commit('SET_QA', data);
    },

    find({ commit, state }) {
      let url = `/res-qa?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('qa'));
          return response.body;
        })
        .then((response) => {
          commit('SET_QALIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/res-qa/${id}`)
        .then((response) => response.body)
        .then(typeAs('qa'))
        .then((item) => {
          commit('SET_QA', item);
        });
    },

    destroy(_, id) {
      return http(`/res-qa/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/res-qa/${id}`, { method: 'PUT', data })
        : http('/res-qa', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/res-qa/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
    // 取得所屬FAQ類別
    getQACates(_, id) {
      const request = id
        ? http(`/qacategorybyID/${id}`)
        : http('/qacategories/all');
      return request.then((response) => response.body);
    },
  },
};
